import { api } from "../api/client";

/** Facial-recognition second-factor endpoints (matching happens server-side). */
export const FaceApi = {
  /** Does the calling officer have a face on file? */
  status: () => api<{ enrolled: boolean }>("/me/face"),

  /** Match a live capture against the stored reference, server-side. */
  verify: (faceDescriptor: number[]) =>
    api<{ verified: boolean; enrolled: boolean }>("/me/face/verify", {
      method: "POST",
      body: JSON.stringify({ faceDescriptor }),
    }),
};
